module.exports = __webpack_public_path__ + "static/media/IMG_3983 vanity close.5f39a14c.JPG";